// Portable KB image URLs (Feature 4317 / #5456).
//
// Article bodies store image src as a RELATIVE API path
// (`/help-articles/images/<uuid>.<ext>`) so authored content isn't pinned to
// the API host of the environment it was written in. At display time we resolve
// them to absolute against the current API base; in the editor we resolve on
// load (format) and strip back to relative on save (parse).

const IMAGE_PATH = "/help-articles/images/";

/** Rewrite relative KB image src to absolute against the given API base. No-op on already-absolute src. */
export const toAbsoluteImageUrls = (html: string | undefined, apiBase: string): string => {
  if (!html) return html ?? "";
  return html.replace(new RegExp(`(src=["'])${IMAGE_PATH}`, "g"), `$1${apiBase}${IMAGE_PATH}`);
};

/** Rewrite absolute KB image src (any origin) back to the relative API path for storage. */
export const toRelativeImageUrls = (html: string | undefined): string => {
  if (!html) return html ?? "";
  return html.replace(new RegExp(`(src=["'])https?://[^"']*?(${IMAGE_PATH})`, "g"), "$1$2");
};
